import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { headersListaUsuarios } from './auxiliarListaUsuarios';
import { getUsuariosPorVinculo } from '../../services/usuario/userService';
import { formatDate } from '../../utils/functions';
import CustomSpan from '../CustomSpan';
import DetailsTable from '../CustomTable/DetailsTable';
import CustomTableOffcanvas from '../CustomTableOffcanvas';

const ListUsers: React.FC = () => {
  const navigate = useNavigate();
  const [data, setData] = useState<any[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState<string | null>(null);

  const fetchData = async () => {
    try {
      // const userData = await getAllUser();
      const userData = await getUsuariosPorVinculo();
      setData(userData);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
      setError('Ocorreu um erro ao carregar os dados.');
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const tableData: any[] = data.map((item) => ({
    id: item.id,
    stRegistroAtivo: item.stRegistroAtivo === 'S' ? 'Ativo' : 'Inativo',
    nomeCompleto: item.nomeCompleto,
    UnidadeCadastro:
      item.usuarioVinculo?.[0]?.nomeInstituicao || 'Sem vínculo ativo',
    papel: item.usuarioVinculo?.[0]?.papel || 'Sem vínculo ativo',
    interface: item.usuarioVinculo?.[0]?.interface || 'Sem vínculo ativo',
    emailPessoal: item.emailPessoal,
    // Campos extras para o offcanvas
    _stRegistroAtivoRaw: item.stRegistroAtivo,
    _dataRegistro: formatDate(item.dataRegistro),
    _dataUltimaAtualizacao: formatDate(item.dataUltimaAtualizacao),
  }));

  return (
    <CustomTableOffcanvas
      headers={headersListaUsuarios}
      data={tableData}
      offcanvasTitle="Detalhes do Usuário"
      widthOffcanvas="60%"
      filterable
      filterPlaceholder="Pesquisar..."
      itemsPerPage={10}
      onRowClick={(row) => navigate(`ficha/${row.id}/dadosgerais`)}
    >
      {(row) => {
        if (!row) return null;
        const details = {
          id: row.id,
          Status:
            row._stRegistroAtivoRaw === 'S' ? (
              <CustomSpan texto="Ativo" />
            ) : (
              <CustomSpan texto="Inativo" />
            ),
          Usuario: row.nomeCompleto,
          Alocação: row.UnidadeCadastro,
          Papel: row.papel,
          'Data/Hora': row._dataRegistro,
          'Última Atualização': row._dataUltimaAtualizacao,
          'Email Pessoal': row.emailPessoal,
        };
        return <DetailsTable row={details} />;
      }}
    </CustomTableOffcanvas>
  );
};

export default ListUsers;
